import { CountryService } from './../../data/services/country.service';
import { Component, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NavigationStart, Router } from '@angular/router';
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { filter } from 'rxjs';
import { FORM_VALIDTIONS } from 'src/app/core/constant/constant';
import { settingsModel } from 'src/app/core/models/settings.model';
import { UserService } from 'src/app/data/services/user.service';
import { AuthService } from 'src/app/shared/auth.service';
import { Helper } from 'src/app/shared/helper';
import { LanguageService } from 'src/app/shared/language.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent {
  public visible = false;
  loginModalRef!: NgbModalRef;
  registerModalRef!: NgbModalRef;
  phoneCodeModalRef!: NgbModalRef;
  forgotModalRef!: NgbModalRef;
  resetModalRef!: NgbModalRef;
  otpModalRef!: NgbModalRef;
  filterValue = '';
  loginForm!: FormGroup;
  registerForm!: FormGroup;
  forgotForm! : FormGroup ;
  resetPasswordForm! : FormGroup ;
  otpForm!: FormGroup;
  passwordsDoNotMatch! : boolean ;
  otpMode: 'login' | 'verify' = 'verify';
  otpRequested = false;
  modalConfig:any = {
    centered: true,
    windowClass: 'modal-md',
    backdrop: 'static',
    keyboard: false // Prevent closing on ESC keypress
  };

  closeResult = '';
  isProductPage = false;
  userSettings!: settingsModel;
  countryList: any;
  selectedCountryCode!: string;
  showPassword: boolean = false;
  FORM_VALIDATION = FORM_VALIDTIONS
  languages: any[] = [];
  @ViewChild('login', { static: true }) login!: TemplateRef<any>;
  @ViewChild('register', { static: true }) register!: TemplateRef<any>;
  @ViewChild('forgot_password', { static: true }) forgot_password!: TemplateRef<any>;
  @ViewChild('reset_password', { static: true }) reset_password!: TemplateRef<any>;
  @ViewChild('phoneCode', { static: true }) phoneCode!: TemplateRef<any>;
  @ViewChild('otp_verification', { static: true }) otp_verification!: TemplateRef<any>;
  @Output() loginEmmiter = new EventEmitter<any>();


  constructor(
    private modalService: NgbModal,
    private userService: UserService,
    private authService: AuthService,
    private _fb: FormBuilder,
    public helper: Helper,
    private _countryService: CountryService,
    private langService: LanguageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.isProductPage = this.router.url === '/product';
    this.userService._settingsObservable.subscribe((res: any) => {
      this.userSettings = res?.data;
    });
    this.languages = this.langService.supportedLanguages;

    // Close modal on back button click (NavigationStart)
    this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(() => {
      if (this.loginModalRef || this.registerModalRef || this.forgotModalRef || this.otpModalRef) {
        this.loginModalRef?.close();
        this.registerModalRef?.close();
        this.forgotModalRef?.close();
        this.resetModalRef?.close();
        this.otpModalRef?.close();
      }
    });
  }

  open() {
    setTimeout(() => {
      this.isProductPage = this.router.url === '/product';
    }, 100);
    this.__initForm();
    this.loginModalRef = this.modalService.open(this.login, this.modalConfig);
  }

  registerModal() {
    setTimeout(() => {
      this.isProductPage = this.router.url === '/product';
    }, 100);
    this.languages = this.langService.supportedLanguages;

    this.__initRegisterForm();
    // this.getCountry();
    if (this.loginModalRef) {
      this.loginModalRef.close();
      this.registerModalRef = this.modalService.open(
        this.register,
        this.modalConfig
      );
    } else {
      this.registerModalRef = this.modalService.open(
        this.register,
        this.modalConfig
      );
    }
  }

  loginModal() {
    this.registerModalRef?.close();
    this.open();
  }

  forgotModal(){
    setTimeout(() => {
      this.isProductPage = this.router.url === '/product';
    }, 100);
    this.loginModalRef?.close();
    this.__initForgotForm();
    this.forgotModalRef = this.modalService.open(this.forgot_password , this.modalConfig)
  }

  __initForm() {
    this.loginForm = this._fb.group({
      email: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern(this.FORM_VALIDATION.pattern),
      ]),
      deviceToken : new FormControl('1234'),
      deviceType : new FormControl(2)
    });
  }

  __initRegisterForm() {
    this.registerForm = this._fb.group({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      phone: new FormControl('', [
        Validators.required,
        this.helper.phoneValidator(this.helper.phoneMinLength, this.helper.phoneMaxLength),
      ]),
      email: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern(this.FORM_VALIDATION.pattern),
      ]),
      preferredLanguage: new FormControl('en', [Validators.required]),
    });
  }

  __initForgotForm() {
    this.forgotForm = this._fb.group({
      email : new FormControl('' , [Validators.required , Validators.email, Validators.pattern(this.FORM_VALIDATION.pattern)]),
      newPassword: new FormControl('', [Validators.required , Validators.minLength(this.FORM_VALIDATION.password_length)]),
    })
  }

  __initRestPasswordForm() {
    this.resetPasswordForm = this._fb.group({
      email: new FormControl(''),
      emailOtp : new FormControl('' , [Validators.required , Validators.minLength(this.FORM_VALIDATION.password_length) , Validators.maxLength(this.FORM_VALIDATION.password_length)]),
      password : new FormControl('' , [Validators.required , Validators.minLength(this.FORM_VALIDATION.password_length)]),
      confirmPassword : new FormControl('' , [Validators.required , Validators.minLength(this.FORM_VALIDATION.password_length)])
    })
  }

  __initOtpForm(email: string = '') {
    this.otpForm = this._fb.group({
      email: new FormControl(email, [Validators.required, Validators.email, Validators.pattern(this.FORM_VALIDATION.pattern)]),
      otp: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]),
    });
  }

  getCountry() {
    this._countryService.getCountryData().subscribe((res) => {
      this.countryList = res;
    });
  }

  onCodeClick() {
    this.phoneCodeModalRef = this.modalService.open(
      this.phoneCode,
      this.modalConfig
    );
  }

  getCountryCode(countryCode: any) {
    return countryCode.replace('+', '');
  }

  selectedCode(code: any) {
    this.registerForm.patchValue({
      phoneCode: code,
    });
    this.selectedCountryCode = this.getCountryCode(code);
    this.phoneCodeModalRef.close();
  }

  onLogin() {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    const param = {
      loginBy: 1,
      email: this.loginForm.value.email,
    }

    this.authService.login(param).subscribe((res) => {
      if (res) {
        this.openOtpModal('login', this.loginForm.value.email, true);
      }
    });
  }

  openOtpModal(mode: 'login' | 'verify', email: string = '', otpRequested: boolean = false) {
    this.otpMode = mode;
    this.otpRequested = otpRequested;
    this.__initOtpForm(email);
    this.loginModalRef?.close();
    this.registerModalRef?.close();
    this.forgotModalRef?.close();
    this.resetModalRef?.close();
    this.otpModalRef = this.modalService.open(this.otp_verification, this.modalConfig);
  }

  requestOtp() {
    if (!this.otpForm.get('email')?.value) {
      this.otpForm.get('email')?.markAsTouched();
      return;
    }
    const payload = {
      email: this.otpForm.value.email,
      purpose: this.otpMode,
    };
    this.authService.sendOtp(payload).subscribe((res) => {
      if (res) {
        this.otpRequested = true;
      }
    });
  }

  verifyOtp() {
    if (this.otpForm.invalid) {
      this.otpForm.markAllAsTouched();
      return;
    }
    const payload = {
      email: this.otpForm.value.email,
      otp: this.otpForm.value.otp,
      purpose: this.otpMode,
    };
    this.authService.verifyOtp(payload).subscribe((res) => {
      if (res) {
        this.otpModalRef.close();
        this.otpRequested = false;
        if (this.isProductPage) {
          this.loginEmmiter.emit(true);
          this.isProductPage = false;
        }
      }
    });
  }

  onRegister() {
    // Trim each string value in the form controls
    Object.keys(this.registerForm.controls).forEach(controlName => {
      const control = this.registerForm.get(controlName);

      if (control && typeof control.value === 'string') {
        // Trim the string value
        control.setValue(control.value.trim());
      }
    });
    if (
      this.registerForm.invalid
    ) {
      this.registerForm.markAllAsTouched();
      return;
    }

    let json = {
      firstName: this.registerForm.value.firstName,
      lastName: this.registerForm.value.lastName,
      email: this.registerForm.value.email,
      mobile: this.registerForm.value.phone.toString(),
      preferredLanguage: this.registerForm.value.preferredLanguage,
    };

    this.authService.register(json).subscribe((res) => {
      if (res) {
        this.registerModalRef.close();
        this.openOtpModal('verify', this.registerForm.value.email, true);
      }
    });
  }

  show_password() {
    this.showPassword = !this.showPassword;
  }

  onForgot(){

     // Trim each string value in the form controls
     Object.keys(this.forgotForm.controls).forEach(controlName => {
      const control = this.forgotForm.get(controlName);

      if (control && typeof control.value === 'string') {
        // Trim the string value
        control.setValue(control.value.trim());
      }
    });

    if(this.forgotForm.invalid){
      this.forgotForm.markAllAsTouched();
      return;
    }

    let json = {
      email: this.forgotForm.value.email,
      newPassword: this.forgotForm.value.newPassword,
    };

    this.authService.forgotPassword(json).subscribe((res) => {
      if (res) {
        this.forgotModalRef.close();
        this.__initForgotForm();
        this.open();
      }
    });
  }

  onReset(){
    if(this.resetPasswordForm.invalid){
      this.resetPasswordForm.markAllAsTouched();
      return ;
    }
    if (this.resetPasswordForm.value.password === this.resetPasswordForm.value.confirmPassword) {
      this.passwordsDoNotMatch = false;
    } else {
      this.passwordsDoNotMatch = true;
      return ;
    }

    let json = {
      email : this.resetPasswordForm.value.email ,
      emailOtp : this.resetPasswordForm.value.emailOtp ,
      password : this.resetPasswordForm.value.password
    }

    this.userService.reset_password_with_email(json).then((res) => {
      this.resetModalRef.close();
      this.open();
    })
  }
}
